var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#link_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 8.125A4.375 4.375 0 0 1 4.375 3.75h5.25a4.375 4.375 0 0 1 0 8.75H8.607a1.872 1.872 0 0 1 0-1.25h1.018a3.125 3.125 0 1 0 0-6.25h-5.25a3.125 3.125 0 1 0 0 6.25h.41a5.687 5.687 0 0 0 0 1.25h-.41A4.375 4.375 0 0 1 0 8.125M10.375 7.5h1.018a1.872 1.872 0 0 1 0 1.25h-1.018a3.125 3.125 0 1 0 0 6.25h5.25a3.125 3.125 0 1 0 0-6.25h-.41a5.683 5.683 0 0 0 0-1.25h.41a4.375 4.375 0 0 1 0 8.75h-5.25a4.375 4.375 0 0 1 0-8.75",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "link_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgLink;